var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoc2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 119,
    viewBox: "0 0 97 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5683 73.9013H71.8795M8.65444 2.81813C7.14184 2.85532 5.70371 3.48243 4.6472 4.56556C3.59069 5.64868 2.99954 7.10196 3 8.61503V110.372C2.99952 111.884 3.59027 113.337 4.64616 114.42C5.70205 115.503 7.13944 116.131 8.65154 116.169H87.7963C89.3337 116.169 90.8082 115.558 91.8953 114.471C92.9824 113.384 93.5932 111.909 93.5932 110.372V31.7793H70.4027C68.8896 31.7422 67.451 31.1146 66.3944 30.0309C65.3379 28.9471 64.747 27.4931 64.7483 25.9795V2.78906L8.65444 2.81813ZM64.4866 2.81813L93.4478 31.7793L64.4866 2.81813ZM24.5683 56.3624H71.8795H24.5683ZM24.5683 91.4402H71.8795H24.5683Z",
    stroke: "#228AFF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc2);
export default __webpack_public_path__ + "static/media/doc2.4b2990408f090a71a8b652651d9df576.svg";
export { ForwardRef as ReactComponent };